<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="show-modal-change-pass-code"
      data-bs-toggle="modal"
      data-bs-target="#modalChangePassCode"
    ></button>
    <div
      class="modal fade"
      id="modalChangePassCode"
      tabindex="-1"
      aria-labelledby="modalChangePassCodeLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"></h5>
            <i
              style="cursor: pointer"
              class="material-icons btn-close-modal justify-content-end"
              data-bs-dismiss="modal"
              >clear</i
            >
          </div>
          <div class="modal-body">
            <div class="text-center pb-3">
              <span style="font-weight: bold; color: #3f3fbf; font-size: 22px;">Reset Pin</span>
            </div>
            <div class="text-center pb-3">
              <span style="font-size: 20px; font-weight: bold;">Mobile: </span>
              <span style="font-size: 20px; margin-left: 8px; letter-spacing: 2px;">{{ member.phone_number }}</span>
            </div>
            <div class="text-center pb-3">
              <span style="color: #3f3fbf; font-size: 18px;">Reset to</span>
            </div>
            <div class="d-flex flex-column align-items-center gap-2 mb-3">
              <button
                :class="['btn btn-primary']"
                @click="handleResetPasscode(typeDefault)"
                :disabled="loading"
              >
                <span v-if="loading && passcode === typeDefault" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                0000
              </button>
              <button
                :class="['btn btn-primary']"
                @click="handleResetPasscode(typeDDMM)"
                :disabled="loading"
              >
                <span v-if="loading && passcode === typeDDMM" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                DDMM
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="position-fixed top-1 end-1 z-index-9999 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "@vuepic/vue-datepicker/dist/main.css";
import MemberService from "../../../services/member.service";
import $ from "jquery";

export default {
  name: "ChangePassCode",
  components: {
    MaterialSnackbar,
  },
  props: {
    keyReload: {
      type: String,
      required: true,
    },
    idSelected: {
      type: Number,
      default: 0,
    },
    member: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      message: "",
      snackbar: null,
      loaderActive: false,
      passcode: "",
      typeDefault: 1,
      typeDDMM: 2,
      loading: false,
    };
  },
  methods: {
    handleResetPasscode(type) {
      this.passcode = type;
      this.loading = true;

      var dataForm = {
        phone_number: this.member.phone_number,
      }
      var ApiService = null;

      if (type === this.typeDefault) {
        dataForm.passcode = '0000';
        ApiService = MemberService.changePassCode
      } else if (type === this.typeDDMM) {
        dataForm.phone_code = this.member.phone_code;
        ApiService = MemberService.sendResetToInitialPasscode
      }

      ApiService(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = "Reset Pin Successful";
            $('.btn-close-modal').click();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
          }
          this.loading = false;
          this.setTimeOutNotification();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.loading = false;
          this.setTimeOutNotification();
        }
      );
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
};
</script>

<style scoped>
.modal {
  z-index: 99999;
}

.modal-dialog {
  max-width: 75vw;
  max-width: 500px !important;
}

.modal-body {
  max-height: 75vh;
  overflow-y: auto;
  padding-bottom: 25px;
}

.date-time-dashboad .dp__input_wrap {
  min-width: 200px !important;
  width: 250px;
}

.table-responsive::-webkit-scrollbar {
  height: 7px;
}

.table-responsive::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.table-responsive::-webkit-scrollbar-thumb {
  background: #888;
}

.table-responsive::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.btn-primary {
  background: #2677D9  !important;
  border: none !important;
  font-weight: bold;
  color: #fff !important;
}
.btn-primary:active, .btn-primary:focus {
  background: #2d2d7f;
  border-color: #2d2d7f;
}

.form-control:disabled,
.form-control[readonly] {
  padding: 2px !important;
}

.text-green {
  color: #ffbe30;
}

.otp-input:focus {
  outline: none !important;
}

.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input::placeholder {
  font-size: 15px;
  text-align: center;
  font-weight: 600;
}

#phone_number {
  padding: 0px !important;font-size: 1.1rem; margin-top: 6px;
}

#phone_code {
  padding: 0px !important;font-size: 1.1rem;
  cursor: not-allowed;
  background-image: linear-gradient(0deg, var(--label-color) 2.1px, rgba(156, 39, 176, 0) 0), linear-gradient(0deg, #f0f2f5 1px, rgba(209, 209, 209, 0) 0) !important;
}
</style>

